import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './index.scss';

export default (props) => (
    <ScrollView height={'100%'} width={'100%'} className={'ant-card-layout'} style={props.style}>
        <div
            className={'dx-card content'}
            style={{
                width: props.width !== undefined ? props.width : '400px',
                padding: props.padding !== undefined ? props.padding : '30px',
                marginLeft: props.marginLeft !== undefined ? props.marginLeft : undefined,
                marginRight: props.marginRight !== undefined ? props.marginRight : undefined,
                transform: props.scale !== undefined ? 'scale(' + props.scale + ')' : 'scale(1)'
            }}
        >
            {props.children}
        </div>
    </ScrollView>
);
